import { ShieldCheck, MapPin } from "lucide-react";
import { trackContact, waLink } from "../lib/analytics";

const INDICATORS = [
  { value: "1.200+", label: "Impianti installati" },
  { value: "Dal 1982", label: "oltre 40 anni di esperienza" },
  { value: "5 anni", label: "di garanzia" },
];

const LOGOS = [
  { src: "/assets/references/marina-militare.webp", alt: "Marina Militare", badge: true },
  { src: "/assets/references/enel.webp", alt: "ENEL" },
  { src: "/assets/references/eni.webp", alt: "ENI" },
  { src: "/assets/references/terna.webp", alt: "Terna" },
  { src: "/assets/references/rfi.webp", alt: "RFI" },
  { src: "/assets/references/conad.webp", alt: "Conad" },
  { src: "/assets/references/cigierre.webp", alt: "Cigierre" },
];

export default function Sf1Inizia() {
  return (
    <div>
      <div className="lg:grid lg:grid-cols-[1.02fr_0.98fr] lg:items-start lg:gap-12">
        <div className="lg:row-start-1 lg:col-start-1">
          <p className="sf-eyebrow">Industria · Logistica · Ristorazione</p>
          <h1 className="sf-title mt-4 text-[34px] md:text-[56px]" data-testid="sf-h1">
            Protezione continua dai roditori. <span className="sf-t2">Senza biocidi.</span>
          </h1>
          <p className="mt-4 max-w-xl text-[16px] leading-[1.6] text-[#5B6670] md:text-[17px]">
            Per ambienti in cui igiene, sicurezza e continuità operativa sono prioritarie. TRANS RAT trasmette microvibrazioni
            controllate attraverso la pavimentazione e rende le aree protette inospitali per topi e ratti, senza esche né
            trappole.
          </p>
          <div className="mt-4 flex flex-wrap gap-2" data-testid="sf-hero-badges">
            <span className="inline-flex items-center gap-1.5 rounded-full border border-[#E3E6EA] bg-white px-3 py-1 text-[11px] font-semibold text-[#1e2830]">
              <ShieldCheck className="h-3.5 w-3.5" /> Tecnologia brevettata
            </span>
            <span className="inline-flex items-center gap-1.5 rounded-full border border-[#E3E6EA] bg-white px-3 py-1 text-[11px] font-semibold text-[#1e2830]">
              <MapPin className="h-3.5 w-3.5" /> Made in Italy
            </span>
          </div>
        </div>

        <div className="relative mt-5 lg:row-span-2 lg:row-start-1 lg:col-start-2 lg:mt-0">
          <figure className="relative h-[240px] overflow-hidden rounded-[12px] border border-[#E3E6EA] shadow-[0_10px_30px_rgba(30,40,48,0.10)] md:h-[340px] lg:h-full lg:min-h-[440px]" data-testid="sf-hero-photo">
            <img
              src="/assets/trans-rat-installed-800.webp"
              srcSet="/assets/trans-rat-installed-800.webp 800w, /assets/trans-rat-installed.webp 1200w"
              sizes="(max-width: 1023px) calc(100vw - 32px), 620px"
              alt="TRANS RAT installato: diffusore sismico professionale ancorato al pavimento"
              width="800"
              height="535"
              fetchPriority="high"
              className="h-full w-full object-cover"
            />
          </figure>
          <div className="absolute bottom-3 left-3 flex items-center gap-2.5 rounded-[12px] border border-[#E3E6EA] bg-white p-3 shadow-[0_10px_30px_rgba(30,40,48,0.16)]">
            <span className="block h-2.5 w-2.5 shrink-0 rounded-full bg-[#f2dc3c]" />
            <span>
              <span className="block text-[12.5px] font-bold text-[#1e2830]">TRANS RAT</span>
              <span className="block text-[10.5px] text-[#5B6670]">Diffusore sismico professionale</span>
            </span>
          </div>
        </div>

        <div className="mt-6 lg:row-start-2 lg:col-start-1">
          <div className="grid grid-cols-3 gap-4 border-t border-[#E3E6EA] pt-5" data-testid="sf-indicators">
            {INDICATORS.map((i) => (
              <div key={i.label}>
                <p className="text-[clamp(1.5rem,5.5vw,2rem)] font-bold leading-none tracking-[-0.02em] text-[#1e2830]">{i.value}</p>
                <span className="mt-1.5 block h-[3px] w-8 rounded-full bg-[#f2dc3c]" />
                <p className="mt-1.5 text-[11px] font-medium leading-snug text-[#5B6670] md:text-xs">{i.label}</p>
              </div>
            ))}
          </div>
          <p className="mt-2 text-[10px] leading-relaxed text-[#8a939c]">Impianti Leonardo Soluzioni installati in Italia e all'estero.</p>
        </div>
      </div>

      <div className="mt-8 rounded-[12px] bg-[#F4F5F7] py-6 lg:mt-10" data-testid="sf-hero-logos">
        <p className="text-center text-[11px] font-semibold uppercase tracking-[1.4px] text-[#5B6670]">Si sono affidati a noi</p>
        <div className="mt-5 flex flex-wrap items-center justify-center gap-x-8 gap-y-4 px-4">
          {LOGOS.map((l) =>
            l.src ? (
              <img
                key={l.alt}
                src={l.src}
                alt={l.alt}
                width={l.badge ? 64 : 72}
                height="36"
                loading="lazy"
                className={l.badge ? "h-8 w-auto rounded-[6px] md:h-12" : "h-7 w-auto md:h-9"}
              />
            ) : (
              <span key={l.label} className="flex h-7 items-center justify-center rounded-[6px] border border-dashed border-[#c9cfd6] bg-white px-3 text-[9.5px] font-semibold uppercase tracking-[1px] text-[#5B6670] md:h-9 md:text-[10px]">
                {l.label}
              </span>
            )
          )}
        </div>
        <p className="mt-4 text-center text-[10px] text-[#8a939c]">Referenze relative ai sistemi Leonardo Soluzioni.</p>
      </div>

      <a href={waLink()} target="_blank" rel="noopener noreferrer" onClick={() => trackContact("whatsapp_footer")} className="mt-5 inline-flex text-[13px] font-semibold text-[#1e2830] underline underline-offset-4 hover:text-[#5B6670]">
        Oppure scriveteci su WhatsApp
      </a>
    </div>
  );
}
